<template>
  <v-card
    class="rounded-xl"
    outlined
    min-width="100%"
  >
    <div class="pa-4">
      <v-row no-gutters class="pb-2">
        <StudRating/>
      </v-row>
      <v-list>
        <v-list-item-title class="text-subtitle-1 font-weight-medium text-center mb-2">{{user.full_name}}
        </v-list-item-title>
        <v-divider class=""></v-divider>
        <v-list-item-subtitle class="text--secondary mt-2">Факультет</v-list-item-subtitle>
        <p class="mb-2">{{user.facility}}</p>
        <v-list-item-subtitle class="text--secondary mt-2 text-left">Уровень образования</v-list-item-subtitle>
        <p class="mb-2">{{ user.edu_level}}</p>
        <v-list-item-subtitle class="text--secondary mt-2">Направление подготовки (специальность)</v-list-item-subtitle>
        <p class="mb-2">{{user.speciality_name}}</p>
        <v-list-item-subtitle class="text--secondary">Отличительный признак</v-list-item-subtitle>
        <p class="mb-2">{{setPrivilege}}</p>
      </v-list>
    </div>
  </v-card>
</template>

<script>
    import axios from 'axios';
    import StudRating from "./StudRating.vue";
    import {mapState, mapMutations, mapActions, mapGetters} from 'vuex';

    export default {
        name: 'CardPersPerf',
        components: {
            StudRating
        },
        data: () => ({}),
        mounted() {
        },
        updated() {
        },
        methods: {},
        computed: {
            ...mapState({
                user: state => state.mainHostel.user,
            }),
            ...mapGetters({
                setPrivilege: 'mainHostel/setPrivilege'
            }),

        },
    }
</script>

<style scoped>
</style>